import React from 'react';

/**
 * Horizontal scrollable year pills (mobile) or vertical sidebar list (desktop).
 *
 * Props:
 *   years         – array of year numbers
 *   currentYear   – currently selected year
 *   onChange      – (year) => void
 */
export default function YearSelector({ years = [], currentYear, onChange }) {
  if (!years.length) return null;

  return (
    <nav
      className="gallery-year-selector"
      role="tablist"
      aria-label="Select year"
    >
      {years.map((year) => (
        <button
          key={year}
          role="tab"
          aria-selected={year === currentYear}
          aria-controls={`panel-year-${year}`}
          id={`tab-year-${year}`}
          className={year === currentYear ? 'active' : ''}
          onClick={() => onChange?.(year)}
        >
          {year}
        </button>
      ))}
    </nav>
  );
}